import React, { useEffect, useState } from "react";
import GetData from "../../Api/GetData";
import { NavLink, useNavigate } from "react-router-dom";
const Questions = (props) => {
  const history = useNavigate();
  const [notificationData, setNotificationData] = useState([]);
  useEffect(() => {





    const response = GetData.GetNotificationsAndCorrections();
    response.then((value) => {
      console.log('value for dashboard is  ==========>>>', value)
      setNotificationData(value?.data)
    })

  }, []);
  const handleEditBtn = () => {
    // console.log('========??????', props?.errormessage)
    if (props?.errormessage) {


      localStorage.setItem("editFormStatus", "false");
      history('/AOF')
    }
    else {

      localStorage.setItem("editFormStatus", "true");
      history('/AOF')
    }

  }
  const handleWhatsapp = () => {
    window.open('https://api.whatsapp.com/send/?phone=923146398227&text&app_absent=0', '_blank').focus();
  }
  return (
    <>
      {notificationData?.length > 0 &&
        <>

          {notificationData.map(notifydata => (

            <>
              {notifydata?.status == 'true' &&
                <>
                  <div className="bg-white mb-3 shadow edge-notification p-4">

                    <div className="d-flex">
                      <BellIcon />
                      <span className="m10 notification-title">{notifydata?.title}</span>
                    </div>

                    <div className="ml12">

                      <p className="text-gray description-text">
                        {notifydata?.description}
                      </p>
                      {/* <NavLink className="text-decoration-none" to='/AOF'> */}
                      <span className="t-pink" onClick={() => handleEditBtn()}><b> Edit Form</b></span>

                      {/* </NavLink> */}

                    </div>
                    <hr />

                  </div>

                </>
              }
            </>
          ))}
        </>}
      <div className="bg-Pink mb-5 mb-md-0 edge px-4 px-md-3 py-3">
        <h3 className="me-auto text-white fs16 fw-800">Questions?</h3>
        <p className="heading">
          Don't hesitate to contact our support team on the following
          numbers.
        </p>
        <div className="d-block d-sm-flex d-md-block d-lg-flex mt20">
          <p
            className="text-white fs-small fw-800 mbt-4"
          >
            UAN
          </p>
          <p className="ms-auto text-white fs-small fw-bold mbt-4">
            021 111 639 825 Ext 147
          </p>
        </div>
        <div className="d-block d-sm-flex d-md-block d-lg-flex">
          <p
            className="text-white fs-small fw-800 mbt-4"
          >
            WhatsApp
          </p>
          <p className="ms-auto text-white fs-small fw-bold mbt-4" >
            <a className="text-white" onClick={() => handleWhatsapp()}>+92 314 NEXTCAP (6398227)</a>
          </p>
        </div>
        <div className="d-block d-sm-flex d-md-block d-lg-flex">
          <p
            className="text-white fs-small fw-800 mbt-4"
          >
            Email
          </p>
          <p className="ms-auto text-white fs14 fw-800 mbt-4">
            cs@nextcapital.com.pk
          </p>
        </div>
      </div>
    </>
  );
}

export default Questions;

const BellIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill="#E92A5E" />
    <path d="M15.9998 23.9999C16.8798 23.9999 17.5998 23.2799 17.5998 22.3999H14.3998C14.3998 23.2799 15.1118 23.9999 15.9998 23.9999ZM20.7998 19.1999V15.1999C20.7998 12.7439 19.4878 10.6879 17.1998 10.1439V9.5999C17.1998 8.9359 16.6638 8.3999 15.9998 8.3999C15.3358 8.3999 14.7998 8.9359 14.7998 9.5999V10.1439C12.5038 10.6879 11.1998 12.7359 11.1998 15.1999V19.1999L10.1678 20.2319C9.66385 20.7359 10.0158 21.5999 10.7278 21.5999H21.2638C21.9758 21.5999 22.3358 20.7359 21.8318 20.2319L20.7998 19.1999Z" fill="white" />
  </svg>

)